import { AfterViewInit, Component, EventEmitter, forwardRef, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { NG_VALUE_ACCESSOR, FormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { RTL } from 'src/app/@theme/const';
import { ThemeLayoutService } from 'src/app/@theme/services/theme-layout.service';
import { BaseService } from 'src/app/tabms/services/base/base.service';
import { FieldDicHelperService } from 'src/app/tabms/services/global/field-dic-helper.service';
import { TabConst } from 'src/app/tabms/tab-consts';
import { Calendar } from 'primeng/calendar';

@Component({
  selector: 'app-year-picker',
  templateUrl: './year-picker.component.html',
  styleUrl: './year-picker.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => YearPickerComponent),
      multi: true
    }
  ]
})
export class YearPickerComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() control: FormControl | null = null;
  @Input() size: 'default' | 'compact' | 'xs' = TabConst.DEFAULTSIZE
  @Input() fieldName: string
  @Input() validate: boolean = true //to apply validation only if form not criteria
  @Input() customStyle: string

  @ViewChild('yearCalendar') yearCalendar: Calendar;
  @Output() yearSelected = new EventEmitter<number>();

  selectedDate: Date
  systemMenuId: string
  currentLang: string
  placeholder: string


  private destroy$: Subject<void> = new Subject<void>()

  private onChange = (value: any) => { };
  private onTouched = () => { };

  constructor(
    private baseService: BaseService,
    private themeLayoutService: ThemeLayoutService,
    private fieldDicHelperService: FieldDicHelperService,
    private activateRoute: ActivatedRoute
  ) {
    this.activateRoute.params.pipe(takeUntil(this.destroy$)).subscribe({
      next: (params) => {
        this.systemMenuId = params['id']
      }
    })

    this.currentLang = this.baseService.getCurrentLanguage();

    this.themeLayoutService.directionChange.pipe(takeUntil(this.destroy$)).subscribe({
      next: (dir) => {
        this.currentLang = dir === RTL ? 'ar' : 'en'
        this.loadFieldData();
      }
    })

  }


  ngOnInit(): void {
    this.loadFieldData();

    this.baseService.createFormDisplay
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          // console.log('subscribe createFormDisplay in input', res);

          if (res?.show && res?.id === null) {
            this.loadFieldData(); // create only
          }
        },
      });
  }

  ngAfterViewInit(): void {
    // Set initial value if provided
    // if (this.control) {
    //   this.writeValue(this.control.value);
    // }

    this.control?.valueChanges.pipe(takeUntil(this.destroy$)).subscribe({
      next: (value) => {
        this.writeValue(value);
      }
    });

    // Monitor control disabled state changes
    this.control?.statusChanges.pipe(takeUntil(this.destroy$)).subscribe({
      next: (status) => {
        const isDisabled = this.control?.disabled || false;
        this.setDisabledState(isDisabled);
      }
    });
  }

  onDateSelected(): void {
    if (this.selectedDate) {
      const year = this.selectedDate.getFullYear();
      this.yearSelected.emit(year);
      this.onChange(year);
      this.onTouched();

      // Update form control if provided
      if (this.control) {
        this.control.setValue(year);
      }
    }
  }

  // ControlValueAccessor implementation
  writeValue(value: any): void {

    if (value === null || value === undefined) {
      this.selectedDate = null;
      return;
    }

    if (value) {
      // If value is a number (year), create a date with that year
      if (typeof value === 'number') {
        this.selectedDate = new Date(value, 0, 1); // January 1st of the year
      } else if (value instanceof Date) {
        this.selectedDate = value;
      }
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    // Handle disabled state for PrimeNG Calendar
    if (isDisabled) {
      this.yearCalendar?.inputfieldViewChild?.nativeElement?.setAttribute('disabled', 'true');
    } else {
      this.yearCalendar?.inputfieldViewChild?.nativeElement?.removeAttribute('disabled');
    }
  }

  private loadFieldData() {
    // debugger
    this.fieldDicHelperService
      .getFieldData(this.fieldName, this.systemMenuId, this.validate, this.control, this.currentLang)
      .pipe(takeUntil(this.destroy$))
      .subscribe(({ placeholder, defaultValue, type, disabled }) => {
        // debugger
        this.placeholder = placeholder;
        if (defaultValue && defaultValue !== null && defaultValue !== undefined) {
          this.control.patchValue(defaultValue, { emitEvent: false, onlySelf: true });
        }
        // console.log('disabled', disabled);

        if (disabled) {
          this.control?.disable({ emitEvent: false });
          this.setDisabledState(true);
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
